/**
 * The element behind a selector the code depends on. Throws naming the selector,
 * because a game whose markup and code have drifted apart should say so loudly at
 * startup rather than fail silently halfway through a turn.
 */
export function getElement<T extends HTMLElement = HTMLElement>(selector: string): T {
  const element = document.querySelector<T>(selector);
  if (!element) throw new Error(`Missing element: ${selector}`);
  return element;
}
